import * as React from "react";

import "./informed-delivery-modules.scss";

import {cs}               from "@Common/react/chain-services";
import {itemEditor, ui}   from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {InformedDelivery} from "@Common/ui-components/heavy/item-options/modules/informed-delivery/informed-delivery";
import {
    alterPrepareSaveValue, nestData, renameAttrs,
}                         from "@Common/ui-components/heavy/item-options/modules/informed-delivery/nest-editor-path";
import {chain}            from "@Common/utils/fs";
import {omit}             from "@Common/utils/objects";

export const informedDeliveryModules = ({item, templateOptions}) => [
    {
        load: ({method}, next) => cs(
            ["informedDelivery", ({}, next) => InformedDelivery({
                itemId: item?.itemId,
                agentId: item?.idAgent,
                initData: !item?.tracking ? null : (
                    item.tracking.informedDelivery ? chain(
                        item.tracking.informedDelivery,
                        (_) => ({
                            ...omit(_, ["enableInformedDelivery", "ridealongImage"]),
                            enabled: _.enableInformedDelivery,
                            rideAlongImage: _.ridealongImage,
                        }),
                    ) : {
                        redirectType: item.tracking.redirectType,
                        redirectUrl : item.tracking.redirectUrl,
                    }
                ),
                disabled: method !== "mailing" || (!item?.tracking?.informedDelivery?.representativeImage && !item?.metaData?.ccProofUrls?.[0]),
                templateOptions,
                representativeImage: {
                    url: item.metaData?.ccProofUrls?.[0],
                    maybeLoading: true,
                },
                next
            })],
            ({informedDelivery}) => next({
                itemEditor: {
                    ...informedDelivery.editor,
                    prepareSave: alterPrepareSaveValue(informedDelivery.editor.prepareSave, [
                        nestData(["tracking", "informedDelivery"]),
                        renameAttrs([
                            {
                                outside: "enableInformedDelivery",
                                inside : "enabled",
                            },
                            {
                                outside: "ridealongImage",
                                inside : "rideAlongImage",
                            },
                        ]),
                    ]),
                },
                ui: ({showErrors}) => !informedDelivery.disabled && (
                    <div className="informed-delivery-modules-0d3" xd-qa-type="card" xd-qa-name="Informed Delivery">

                        {informedDelivery.renderHeader({})}

                        {informedDelivery.render?.({showErrors})}
                    </div>
                ),
            }),
        ),
        expo: [ui("informedDelivery"), itemEditor],
        requires: ["method"],
    },
];
